const DivideLine: React.FC<{ padding?: string }> = ({ padding = "12px 8px" }) => {
  return (
    <div style={{ backgroundColor: "#FFF", padding: padding }}>
      <div style={{ border: "1px solid #F4F5F7" }} />
    </div>
  );
};

export default DivideLine;
